import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { SelectivePreloadingStrategy } from './selective-preloading-strategy';
import { ShareRideHomeComponent } from './share-ride-home/share-ride-home.component';
import { CaptainShareRideComponent } from './captain-share-ride/captain-share-ride.component';


const appRoutes: Routes = [
  {
    path: 'track/:id',
    component: ShareRideHomeComponent
  },
  {
    path: 'RAPIDO/:id',
    component: ShareRideHomeComponent
  },
  {
    path: 'CAPTAIN/:id',
    component: CaptainShareRideComponent
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(
      appRoutes,
      {
        enableTracing: false, // <-- debugging purposes only
        preloadingStrategy: SelectivePreloadingStrategy,

      }
    )
  ],
  exports: [
    RouterModule
  ],
  providers: [
    SelectivePreloadingStrategy
  ]
})
export class AppRoutingModule { }
